<template>
  <div>
    <div :class="$style.login">
      <div :class="$style.inputGroup">
        <Input :class="$style.input"
          id="rutCliente"
          label="Ingresa tu RUT"
          :ariaLabel="'campo obligatorio'"
          :tabindexinput="'5'"
          @error="(err) => fillErrors(err)"
          @data="writeRut"
          required
          typeinput="rut"
          maxlength="12"
        />
        <Input :class="$style.input"
          id="claveCliente"
          label="Ingresa tu clave de acceso"
          aria-label="Ingresa tu clave de acceso, campo obligatorio"
          required
          :tabindexinput="'6'"
          @error="(err) => fillErrors(err)"
          @data="writePassword"
          typeinput="password"
          maxlength="20"
        />
      </div>
      <div :class="$style.footer">
        <div :class="$style.button">
          <PdsButton
            tabindex="7"
            label="Ingresar a mi cuenta"
            aria-label="Ingresar a mi cuenta, botón"
            :aria-disabled="disableLogin"
            role="primary"
            :class="disableLogin ? $style.buttonDisabled : ''"
            block
            @click="postLogin()"
            :disabled="disableLogin"
            />
        </div>
        <div :class="$style.linkOne" @click="recoveryBeneficiary">
          <PdsLink
          tabindex="8"
            aria-label="No recuerdo mi clave de acceso, enlace"
            :text="textLinkOne"
            link="javascript:;"
            :class="$style.linkStyleOne" />
        </div>
      </div>
    </div>
    <div :class="$style.specialFooter">
      <div :class="$style.backLinkColor">
        <div :class="$style.linkTwo" @click="createBeneficiary">
          <PdsLink
            tabindex="9"
            aria-label="Crear mi cuenta de beneficiario, enlace"
            :text="textLinkTwo"
            link="javascript:;"
            :class="$style.linkStyleTwo"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PdsButton from '@vue-pds/button';
import PdsLink from '@vue-pds/link';
import Input from '@/components/Input';
import _ from 'lodash';
import { mapActions, mapState, mapGetters } from 'vuex';
import types from '@/constants/types';
import gtmRegister from '@/functions/analitics';
import constantsAnalytics from '@/config/constantsAnalytics';

export default {
  name: 'Login',
  components: {
    PdsLink,
    PdsButton,
    Input,
  },
  data() {
    return {
      rutClient: '',
      password: null,
      textLinkOne: 'No recuerdo mi clave de acceso',
      textLinkTwo: 'Crear mi cuenta de beneficiario',
      error: {},
    };
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  methods: {
    ...mapActions({
      login: types.async.LOGIN,
      saveUser: types.actions.SAVE_USER,
      saveToken: types.actions.SAVE_TOKEN,
      beneficiaryData: types.async.DATA_BENEFICIARY,
      validateBeneficiary: types.async.GET_VALIDATE_BENEFICIARY,
      removeToken: types.actions.REMOVE_TOKEN,
      removeAll: types.actions.REMOVE_ALL,
    }),
    writeRut(rut) {
      this.rutClient = rut;
    },
    writePassword(pass) {
      this.password = pass;
    },
    recoveryBeneficiary() {
      gtmRegister(constantsAnalytics.site.recover, this);
      this.$router.push('/recoverypassword');
    },
    createBeneficiary() {
      gtmRegister(constantsAnalytics.site.create, this);
      this.$router.push('/createpassword');
    },
    async postLogin() {
      if (this.disableLogin) {
        return;
      }
      this.$emit('isLoading', true);

      // agregar validacion checkBeneficiary luego login
      const personalData = await this.login({
        // eslint-disable-next-line radix
        rut: parseInt(this.rutClient.value.rut),
        password: this.password.value,
        dv: this.rutClient.value.dv,
      });

      await this.saveUser({
        Rut: this.rutClient.value.rut,
        Dv: this.rutClient.value.dv,
        names: personalData.data.names,
        surname: personalData.data.surname,
        secondSurname: personalData.data.secondSurname,
        clientId: personalData.data.clientId,
      });

      await this.saveToken({
        token: personalData.data.sessionToken,
      });

      await this.validateBeneficiary({
        rut: this.rutClient.value.rut,
      });

      gtmRegister(constantsAnalytics.site.login, this);
      this.$router.push('/home');
      this.$emit('isLoading', false);
    },
    fillErrors(value) {
      this.error[value.id] = {
        error: value.error,
        id: value.id,
        order: parseFloat(value.order),
      };
    },
  },
  computed: {
    ...mapState({
      loginError: state => state.async[types.async.LOGIN].error,
      errorActive: state => state.async[types.async.LOGIN].loading,
    }),
    ...mapGetters({
      tokenfinal: 'getToken',
      data: 'getSolicitud',
    }),
    disableLogin() {
      let errorForm = this.error;
      errorForm = _.orderBy(errorForm, 'order').filter(err => err.error === true);

      return (this.rutClient === '' || this.rutClient.value === '')
        || (this.password == null || this.password.value === '')
        || errorForm.length > 0 || this.password.value.length < 8;
    },
  },
  watch: {
    loginError(val) {
      if ((val.response !== null || val.isAxiosError) && this.$props.loading && !this.errorActive) {
        this.$emit('error', val.response ? val.response.status : 0);
        this.$emit('isLoading', false);
        this.$emit('showModal', true);
      }
    },
  },
  created() {
    this.removeAll();
  },
};
</script>

<style lang="scss" module>

.buttonDisabled {
  padding: 13.5px 32px;
  color: var(--components-button-primary-disabled-text);
  pointer-events: none;
  cursor: not-allowed;
  background-color: var(--components-button-primary-disabled-background);
  border: 1px solid #e8e8e8;
}

.login {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 344px;
  background-color: white;

  & .inputGroup {
    width: 100%;
    padding-top: 36px;
    margin: 0 auto;

    & .input {
      height: 112px;
      margin: 0 24px;
    }
  }

  & .footer {
    margin: 0 auto;

    & .button {
      max-width: 300px;
    }

    & .linkOne {
      padding: 32px 0 20px;
      cursor: pointer;

      & .linkStyleOne {
        color: #0061a0;
        border-bottom: 1px dashed #0061a0;
      }
    }

    & .linkOne:hover {
      & .linkStyleOne {
        color: #002e6d;
        border-bottom: 1px solid #002e6d;
      }
    }
  }
}

.specialFooter {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  background-color: #f0fbfe;

  & .backLinkColor {
    width: 100%;
    text-align: center;

    & .linkTwo {
      padding: 20px 0 36px;
      cursor: pointer;

      & .linkStyleTwo {
        color: #0061a0;
        border-bottom: 1px dashed #0061a0;
      }
    }

    & .linkTwo:hover {
      & .linkStyleTwo {
        color: #002e6d;
        border-bottom: 1px solid #002e6d;
      }
    }
  }
}

@media (max-width: 767px) {
  .login {
    border-radius: 5px;
  }

  .specialFooter {
    width: 100%;

    & .backLinkColor {
      width: 100%;
      background-color: #035fa4;

      & .linkTwo {
        & .linkStyleTwo {
          color: white;
          border-bottom: 1px dashed white;
        }
      }

      & .linkTwo:hover {
        & .linkStyleTwo {
          color: white;
          border-bottom: 1px solid white;
        }
      }
    }
  }
}

@media (max-width: 360px) {
  .login {
    width: auto;

    & .inputGroup {
      padding: 20px 20px 0;
      margin: 0;

      & .input {
        width: auto;
        margin-left: 0;
      }
    }
  }
}
</style>
